"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchResults = void 0;
var searchResults = {
    content: [
        {
            codeType: "ICD",
            code: "E11.00",
            description: "Type 2 diabetes mellitus with hyperosmolarity without nonketotic hyperglycemic-hyperosmolar coma (NKHHC)",
            shortDescription: "Type 2 diab w hyprosm w/o nonket hyprgly-hypros coma (NKHHC)",
            tenantDefined: true
        },
        {
            codeType: "ICD",
            code: "E11.01",
            description: "Type 2 diabetes mellitus with hyperosmolarity with coma",
            shortDescription: "Type 2 diabetes mellitus with hyperosmolarity with coma",
            tenantDefined: true
        },
        {
            codeType: "ICD",
            code: "E11.10",
            description: "Type 2 diabetes mellitus with ketoacidosis without coma",
            shortDescription: "Type 2 diabetes mellitus with ketoacidosis without coma",
            tenantDefined: true
        },
        {
            codeType: "ICD",
            code: "E11.11",
            description: "Type 2 diabetes mellitus with ketoacidosis with coma",
            shortDescription: "Type 2 diabetes mellitus with ketoacidosis with coma",
            tenantDefined: true
        },
        {
            codeType: "ICD",
            code: "E11.21",
            description: "Type 2 diabetes mellitus with diabetic nephropathy",
            shortDescription: "Type 2 diabetes mellitus with diabetic nephropathy",
            tenantDefined: true
        },
        {
            codeType: "ICD",
            code: "E11.22",
            description: "Type 2 diabetes mellitus with diabetic chronic kidney disease",
            shortDescription: "Type 2 diabetes mellitus w diabetic chronic kidney disease",
            tenantDefined: true
        },
        {
            codeType: "ICD",
            code: "E11.29",
            description: "Type 2 diabetes mellitus with other diabetic kidney complication",
            shortDescription: "Type 2 diabetes mellitus w oth diabetic kidney complication",
            tenantDefined: true
        },
        {
            codeType: "ICD",
            code: "E11.311",
            description: "Type 2 diabetes mellitus with unspecified diabetic retinopathy with macular edema",
            shortDescription: "Type 2 diabetes w unsp diabetic retinopathy w macular edema",
            tenantDefined: true
        },
        {
            codeType: "ICD",
            code: "E11.319",
            description: "Type 2 diabetes mellitus with unspecified diabetic retinopathy without macular edema",
            shortDescription: "Type 2 diabetes w unsp diabetic rtnop w/o macular edema",
            tenantDefined: true
        },
        {
            codeType: "ICD",
            code: "E11.3211",
            description: "Type 2 diabetes mellitus with mild nonproliferative diabetic retinopathy with macular edema, right eye",
            shortDescription: "Type 2 diab with mild nonp rtnop with macular edema, r eye",
            tenantDefined: true
        },
        {
            codeType: "ICD",
            code: "E11.3212",
            description: "Type 2 diabetes mellitus with mild nonproliferative diabetic retinopathy with macular edema, left eye",
            shortDescription: "Type 2 diab with mild nonp rtnop with macular edema, l eye",
            tenantDefined: true
        },
        {
            codeType: "ICD",
            code: "E11.3213",
            description: "Type 2 diabetes mellitus with mild nonproliferative diabetic retinopathy with macular edema, bilateral",
            shortDescription: "Type 2 diabetes with mild nonp rtnop with macular edema, bi",
            tenantDefined: true
        },
        {
            codeType: "ICD",
            code: "E11.3219",
            description: "Type 2 diabetes mellitus with mild nonproliferative diabetic retinopathy with macular edema, unspecified eye",
            shortDescription: "Type 2 diab with mild nonp rtnop with macular edema, unsp",
            tenantDefined: true
        },
        {
            codeType: "ICD",
            code: "E11.3291",
            description: "Type 2 diabetes mellitus with mild nonproliferative diabetic retinopathy without macular edema, right eye",
            shortDescription: "Type 2 diab with mild nonp rtnop without mclr edema, r eye",
            tenantDefined: true
        },
        {
            codeType: "ICD",
            code: "E11.3292",
            description: "Type 2 diabetes mellitus with mild nonproliferative diabetic retinopathy without macular edema, left eye",
            shortDescription: "Type 2 diab with mild nonp rtnop without mclr edema, l eye",
            tenantDefined: true
        },
        {
            codeType: "ICD",
            code: "E11.3293",
            description: "Type 2 diabetes mellitus with mild nonproliferative diabetic retinopathy without macular edema, bilateral",
            shortDescription: "Type 2 diab with mild nonp rtnop without macular edema, bi",
            tenantDefined: true
        },
        {
            codeType: "ICD",
            code: "E11.3299",
            description: "Type 2 diabetes mellitus with mild nonproliferative diabetic retinopathy without macular edema, unspecified eye",
            shortDescription: "Type 2 diab with mild nonp rtnop without macular edema, unsp",
            tenantDefined: true
        },
        {
            codeType: "ICD",
            code: "E11.3311",
            description: "Type 2 diabetes mellitus with moderate nonproliferative diabetic retinopathy with macular edema, right eye",
            shortDescription: "Type 2 diab with mod nonp rtnop with macular edema, r eye",
            tenantDefined: true
        },
        {
            codeType: "ICD",
            code: "E11.3312",
            description: "Type 2 diabetes mellitus with moderate nonproliferative diabetic retinopathy with macular edema, left eye",
            shortDescription: "Type 2 diab with mod nonp rtnop with macular edema, l eye",
            tenantDefined: true
        },
        {
            codeType: "ICD",
            code: "E11.3313",
            description: "Type 2 diabetes mellitus with moderate nonproliferative diabetic retinopathy with macular edema, bilateral",
            shortDescription: "Type 2 diab with moderate nonp rtnop with macular edema, bi",
            tenantDefined: true
        }
    ],
    pageable: {
        sort: { sorted: false, unsorted: true, empty: true },
        pageSize: 20,
        pageNumber: 0,
        offset: 0,
        unpaged: false,
        paged: true
    },
    totalPages: 5,
    last: false,
    totalElements: 86,
    sort: { sorted: false, unsorted: true, empty: true },
    first: true,
    numberOfElements: 20,
    size: 20,
    number: 0,
    empty: false
};
exports.searchResults = searchResults;
//# sourceMappingURL=code-search-results.js.map